import React from 'react';
import { Row, Col, Divider } from 'antd';
import { I18n } from 'react-redux-i18n';
import AdvancedInput from '../../../../../../components/shared/AdvancedInput/AdvancedInput';
import PaymentOrderFormReceivers from '../../receivers/PaymentOrderFormReceivers';
import { ViewType } from '../../../../../../app/enum/viewType';

class PaymentOrderFormBankSlipParcel extends React.Component {
  render() {
    const { viewType, bankSlipParcel } = this.props;
    return (
      <>
        <Row gutter={16}>
          <Col span={8}>
            <AdvancedInput
              label={I18n.t('routes.panel.admin.items.paymentOrder.details.form.config.bankSlipParcel.firstExpirationDate.label')}
              value={bankSlipParcel.firstExpirationDate}
              type="date"
              disabled={viewType === ViewType.EDIT}
            />
          </Col>
          <Col span={8}>
            <AdvancedInput
              label={I18n.t('routes.panel.admin.items.paymentOrder.details.form.config.bankSlipParcel.format.label')}
              value={bankSlipParcel.format}
              disabled={viewType === ViewType.EDIT}
            />
          </Col>
          <Col span={8}>
            <AdvancedInput
              label={I18n.t('routes.panel.admin.items.paymentOrder.details.form.config.bankSlipParcel.instructions.label')}
              value={bankSlipParcel.instructions}
              disabled={viewType === ViewType.EDIT}
            />
          </Col>
        </Row>

        {bankSlipParcel.intervalConfig?.length && bankSlipParcel.intervalConfig.map((o) => (
          <>
            <Divider />

            <label>
              {I18n.t('routes.panel.admin.items.paymentOrder.details.form.config.bankSlipParcel.intervalConfig.label')}
            </label>

            <Row gutter={16}>
              {o.installments &&
                <Col span={6}>
                  <AdvancedInput
                    label={I18n.t('routes.panel.admin.items.paymentOrder.details.form.config.bankSlipParcel.intervalConfig.installments.label')}
                    value={o.installments}
                    disabled={viewType === ViewType.EDIT}
                  />
                </Col>
              }
              {o.amount &&
                <Col span={6}>
                  <AdvancedInput
                    label={I18n.t('routes.panel.admin.items.paymentOrder.details.form.config.bankSlipParcel.intervalConfig.amount.label')}
                    value={o.amount}
                    disabled={viewType === ViewType.EDIT}
                  />
                </Col>
              }
              {o.ratio &&
                <Col span={6}>
                  <AdvancedInput
                    label={I18n.t('routes.panel.admin.items.paymentOrder.details.form.config.bankSlipParcel.intervalConfig.ratio.label')}
                    value={o.ratio}
                    disabled={viewType === ViewType.EDIT}
                  />
                </Col>
              }
              {o.feeAmount &&
                <Col span={6}>
                  <AdvancedInput
                    label={I18n.t('routes.panel.admin.items.paymentOrder.details.form.config.bankSlipParcel.intervalConfig.feeAmount.label')}
                    value={o.feeAmount}
                    disabled={viewType === ViewType.EDIT}
                  />
                </Col>
              }
            </Row>

            {o.receivers && (
              <PaymentOrderFormReceivers
                receivers={o.receivers}
                viewType={viewType}
              />
            )}
          </>
        ))}
      </>
    )
  }
}

export default PaymentOrderFormBankSlipParcel;
